import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const OrderSample = createSvgIcon(
  <path d="m20.715 8.745-3.473-2.857L10.5 23.084V24H0V0h10.5v.33l7.837 2.752-.24.608 5.873 4.822-3.27 3.593-1.665-1.515 1.68-1.845ZM2.25 16.5h6v-6h-6v6Zm8.25.42 4.905-12.495L10.5 2.708V16.92ZM8.25 2.25h-6v6h6v-6Zm-6 16.5v3h6v-3h-6Z M20.625 17.25H24v2.25h-3.375v3.375h-2.25V19.5H15v-2.25h3.375v-3.375h2.25v3.375Z" />,
  'OrderSample'
);

export { OrderSample };
